import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { withLineBreaks } from '@/common/lib/withLinkeBreaks';

import { CharacterDialog } from './CharacterDialog';
import { type TutorialDialogConfig } from './config';

interface TutorialDialogProps {
  config: TutorialDialogConfig;
  onClose: () => void;
}

const TutorialDialog: FC<TutorialDialogProps> = ({ config, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = (): void => {
    if (config.route) {
      navigate(config.route);
    }

    onClose();
  };

  const title = config.title ? withLineBreaks(t(config.title)) : undefined;
  const text = withLineBreaks(t(config.text));
  const buttonText = t(config.buttonText ?? 'OK');

  return (
    <CharacterDialog
      title={title}
      text={text}
      buttonText={buttonText}
      onClose={handleClose}
    />
  );
};

export { TutorialDialog };
